module.exports = __webpack_public_path__ + "static/media/icon-success-dark.ba13579c.png";